<template>
    <div class="bg-white data-table team-data-table table-custom-border rounded b-t-0">
        <div>
            <!-- Embedded on the Resources & AI page the heading and its button
                 live with the page title, so this row steps aside. -->
            <div v-if="!hideHeader"
                class="add_license d-flex justify-content-between align-items-center flex-wrap mb-3 px-3">
                <h3 class="font-weight-bold f-20 text-left mb-0 text-black">{{ $t('aiDocs.title') }}</h3>
                <div class="d-flex align-items-center flex-wrap">
                    <b-button @click="addDocument"
                        class="export equipment d-flex justify-content-center align-items-center w-fit-content"
                        variant="primary">
                        <b-icon icon="plus" class="p-0" aria-hidden="true"></b-icon>
                        <p class="mb-0 ml-2 text-white p-0">{{ $t('aiDocs.addDocument') }}</p>
                    </b-button>
                </div>
            </div>
            <!-- The first load draws the table's shape instead of an empty box. -->
            <div v-if="!isTableMounted" class="mt-2 px-3" style="height: calc(100vh - 140px); overflow: hidden;">
                <b-skeleton-table :rows="40" :columns="5"
                    :table-props="{ hover: true, responsive: true }"></b-skeleton-table>
            </div>
            <b-table v-else :sticky-header="'calc(100vh - 180px)'" responsive :fields="translatedFields" :items="items"
                hover :per-page="perPage" :current-page="currentPage" show-empty :busy.sync="isBusy"
                :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :no-local-sorting="true">
                <template #cell(name)="data">
                    <!-- `data.value` is the value after formatted by the Formatter -->
                    <a :href="`#${data.value
                        .replace(/[^a-z]+/i, '-')
                        .toLowerCase()}`">{{ data.value }}</a>
                </template>
                <template #cell(share_with_driver)="data">
                    <b-form-checkbox v-model="data.value" name="check-button" switch @change="
                        updateDocumentOnToggle(
                            data.item,
                            data.value
                        )
                        " size="lg" class="ml-2" />
                </template>
                <template #cell(description)="data">
                    <p class="item-description mb-0" v-if="data.value && data.value !== 'null'">
                        {{ data.value }}
                    </p>
                    <p v-else class="mb-0">-</p>
                </template>
                <template #cell(tags)="data">
                    <div v-if="data.value.length" class="d-flex align-items-center">
                        <div class="table-tags mr-2">{{ data.value[0].add_tag }}</div>
                        <v-app>
                            <v-tooltip bottom v-if="data.value.length > 1">
                                <template #activator="{ on, attrs }">
                                    <div class="table-tags" v-on="on" v-bind="attrs">+{{ data.value.length - 1 }}</div>
                                </template> <span
                                    v-html="data.value.map((tag) => tag.add_tag).slice(1).join('<br>')"></span>
                            </v-tooltip>
                        </v-app>
                    </div>
                    <p class="mb-0" v-else>-</p>
                </template>
                <template #cell(ai_doc_type)="data">
                    <p class="mb-0">{{ data.value === 'Markdown' ? $t('aiDocs.article') : data.value }}</p>
                </template>
                <template #cell(processing_status)="data">
                    <b-img width="20" height="20" :src="data.item.processing_status === 'Completed' ? require('@/assets/Check.svg') :
                        require('@/assets/check-yellow.svg')
                        "></b-img>
                </template>
                <template #cell(action)="data">
                    <svg v-if="data.item.processing_status === 'Completed'"
                        @click="editDocument(data.item.id, data.item.pk)" class="cursor-pointer mr-4" width="20"
                        height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M18.6426 6.19707C18.8726 6.48384 19 6.85642 19 7.24273C19 7.62904 18.8726 8.00161 18.6426 8.28838C17.186 10.052 13.8704 13.4854 10 13.4854C6.12957 13.4854 2.81403 10.052 1.35741 8.28838C1.12735 8.00161 1 7.62904 1 7.24273C1 6.85642 1.12735 6.48384 1.35741 6.19707C2.81403 4.4335 6.12957 1 10 1C13.8704 1 17.186 4.4335 18.6426 6.19707Z"
                            stroke="#2D69F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                            d="M10.0007 10.0154C11.533 10.0154 12.7752 8.77323 12.7752 7.24091C12.7752 5.70859 11.533 4.4664 10.0007 4.4664C8.46839 4.4664 7.2262 5.70859 7.2262 7.24091C7.2262 8.77323 8.46839 10.0154 10.0007 10.0154Z"
                            stroke="#2D69F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <svg v-if="data.item.processing_status === 'Completed' && data.item.ai_doc_type === 'Doc'"
                        @click="downloadDoc(data.item.pk, data.item.name)" class="mr-4 cursor-pointer" width="20"
                        height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.53943 11.3822L10.001 14.8437L13.4625 11.3822" stroke="#FFC800" stroke-width="1.5"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M10.0001 14.8497V5.15741" stroke="#FFC800" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path
                            d="M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19Z"
                            stroke="#FFC800" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <!-- <svg @click="editDocument(data.item.id)" v-if="$store.state.user.user.team_member.role === 'Admin' ||
                        $store.state.user.user.team_member.role === 'Operations'" class="mr-4 cursor-pointer"
                        width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M7.9452 17.9664L1.71484 19.7109L3.45934 13.4806L14.8678 2.12751C14.9967 1.99564 15.1508 1.89086 15.3207 1.81932C15.4907 1.74779 15.6733 1.71094 15.8578 1.71094C16.0422 1.71094 16.2248 1.74779 16.3948 1.81932C16.5647 1.89086 16.7188 1.99564 16.8477 2.12751L19.2983 4.59196C19.428 4.72066 19.531 4.87381 19.6014 5.04251C19.6717 5.21123 19.7078 5.3922 19.7078 5.57497C19.7078 5.75774 19.6717 5.93871 19.6014 6.10743C19.531 6.27615 19.428 6.42928 19.2983 6.55798L7.9452 17.9664Z"
                            stroke="#2CCE89" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg> -->

                    <svg @click="showDocumentDeletePopup(data.item.pk)" class="cursor-pointer" width="19" height="20"
                        viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 5.15704H17.6139" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path
                            d="M3.0766 5.15704H15.537V17.6175C15.537 17.9846 15.3911 18.3368 15.1315 18.5964C14.8719 18.856 14.5197 19.0019 14.1525 19.0019H4.46109C4.0939 19.0019 3.74175 18.856 3.4821 18.5964C3.22247 18.3368 3.0766 17.9846 3.0766 17.6175V5.15704Z"
                            stroke="#FF0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                            d="M5.84607 5.15347V4.46123C5.84607 3.54325 6.21073 2.66287 6.85984 2.01377C7.50894 1.36466 8.38932 1 9.3073 1C10.2253 1 11.1057 1.36466 11.7548 2.01377C12.4039 2.66287 12.7685 3.54325 12.7685 4.46123V5.15347"
                            stroke="#FF0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M7.23175 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M11.385 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </template>
            </b-table>
            <div class="entries-pagination px-0 px-sm-2" v-if="isTableMounted">
                <div class="d-flex align-items-center flex-wrap">
                    <div class="text-left show-entries mr-md-3 pl-3 pl-md-0 ml-md-0">
                        <b-form-select v-model="perPage" :options="pageOptions" />
                    </div>
                    <div class="pagination">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"
                            aria-controls="my-table"></b-pagination>
                    </div>
                    <p class="my-0 pr-3 pr-md-0 mr-md-1 mt-0 f-14">
                        {{ positionText }}
                    </p>
                </div>
            </div>
        </div>
        <b-modal id="modal-company-ai-docs" centered no-close-on-backdrop no-close-on-esc size="lg"
            :body-class="'px-3 pt-2 overflow-preview-auto'" :footer-class="'d-block border-0 pt-0 pb-3 m-0'"
            :header-class="'align-items-center'" scrollable @shown="resetField">
            <template #modal-header="{ close }">
                <h5 class="modal-title">
                    {{ $t('aiDocs.modalTitle') }}
                </h5>
                <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                    Close Modal
                </b-button>
                <b-dropdown id="dropdown-preview" class="load-dropdown mt-0"
                    v-if="editDocumentFlag && documentData.ai_doc_type === 'Doc'">
                    <template slot="button-content">
                        <b-icon class="dots" icon="three-dots"></b-icon>
                    </template>
                    <b-dropdown-item-button class="mb-2" @click="downloadDoc(documentData.pk, documentData.name)">
                        <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('aiDocs.download') }}</p>
                    </b-dropdown-item-button>
                    <b-dropdown-item-button @click="removeFile()" class="mb-2" v-if="fileName && editDocumentFlag">
                        <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('aiDocs.replaceDoc') }}</p>
                    </b-dropdown-item-button>
                    <b-dropdown-item-button @click="showDocumentDeletePopup(documentData.id)">
                        <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('aiDocs.delete') }}</p>
                    </b-dropdown-item-button>
                </b-dropdown>
                <b-dropdown id="dropdown-preview" text="text" class="load-dropdown mt-0"
                    v-if="!editDocumentFlag && fileName">
                    <template slot="button-content">
                        <b-icon class="dots" icon="three-dots"></b-icon>
                    </template>
                    <b-dropdown-item-button @click="removeFile()">
                        <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('aiDocs.replaceDoc') }}</p>
                    </b-dropdown-item-button>
                </b-dropdown>
            </template>
            <div class="d-block text-center">
                <b-row>
                    <b-col lg="4" md="8" sm="12">
                        <div class="text-left mb-3">
                            <label class="state">{{ $t('aiDocs.typeLabel') }}</label>
                            <b-form-select class="f-12" :options="docTypeOptions" v-model="documentData.ai_doc_type"
                                :disabled="editDocumentFlag">
                            </b-form-select>
                            <p v-if="errors && errors.tagged_model" class="field-error">
                                {{ errors.doc_type[0] }}
                            </p>
                        </div>
                        <!-- <div class="text-left mb-3">
                            <label class="state">{{ $t('aiDocs.tagsLabel') }}</label>
                            <v-select class="f-12" :options="allTags" multiple :reduce="(option) => option.id"
                                v-model="documentData.tags" />
                        </div> -->
                        <div class="text-left mb-3">
                            <label class="state">{{ $t('aiDocs.descriptionLabel') }}</label>
                            <b-form-textarea id="textarea" :placeholder="$t('aiDocs.descriptionPlaceholder')" rows="3"
                                v-model="documentData.description"></b-form-textarea>
                            <p v-if="errors && errors.description" class="field-error pb-4">
                                {{ errors.description[0] }}
                            </p>
                        </div>
                        <div class="text-left">
                            <label class="state">{{ $t('documentsPage.shareWithDriverLabel') }}</label>
                            <b-form-checkbox v-model="documentData.share_with_driver" name="check-button" switch
                                size="lg" class="ml-0-6rem" />
                        </div>
                    </b-col>
                    <b-col lg="8" sm="12" v-if="documentData.ai_doc_type === 'Doc'">
                        <div class="upload-btn-wrapper" v-if="!fileName">
                            <b-img :src="require('@/assets/drop.svg')"></b-img>
                            <button v-if="!fileName" class="foo">
                                {{ $t('aiDocs.dropDocument') }}
                            </button>
                            <button v-else class="foo">{{ fileName }}</button>

                            <input ref="docFile" type="file" name="docFile" v-on:change="handleFileUpload"
                                accept=".pdf, .png, .jpg, .jpeg" />
                            <p v-if="errors && errors.document" class="field-error">
                                {{ errors.document[0] }}
                            </p>
                        </div>
                        <div v-else>
                            <div class="review-media-section mh-470px"
                                :class="mediaType === 'pdf' ? 'overflow-hidden' : ''">
                                <iframe v-if="mediaType === 'pdf'" class="w-100 h-100 border-0" :src="media"></iframe>
                                <div v-else>
                                    <div id="ai-panzoom-element" ref="panzoomElement">
                                        <img :src="media" class="w-100 h-100 img-section" />
                                    </div>
                                    <div class="d-flex align-items-center justify-content-center zoom-section">
                                        <b-icon @click="zoom(1)" icon="zoom-in"
                                            style="fill:white; cursor: pointer;"></b-icon>
                                        <b-icon @click="zoom(-1)" class="ml-3" icon="zoom-out"
                                            style="fill:white;cursor: pointer;"></b-icon>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <b-col lg="8" sm="12" class="mt-1-8rem" v-else>
                        <vue-editor class="ai-markdown-editor" v-model="documentData._markdown_text"
                            :editor-toolbar="customToolbar" />
                        <p v-if="errors && errors._markdown_text" class="field-error mt-2">
                            {{ errors._markdown_text[0] }}
                        </p>
                    </b-col>
                </b-row>
            </div>
            <template #modal-footer="">
                <div class="text-right modal-footer border-0 p-0 mt-4">
                    <b-button class="mx-0 h-40px w-100px m-0 mr-3" @click="$bvModal.hide('modal-company-ai-docs');"
                        variant="secondary">{{ editDocumentFlag ? $t('aiDocs.close') : $t('aiDocs.cancel') }}</b-button>
                    <b-button class="mx-0 mb-0 h-40px w-100px m-0" variant="primary" @click="sendDocumentData">{{
                        $t('aiDocs.save') }}</b-button>
                </div>
            </template>
        </b-modal>
        <DeleteModal :message="$t('aiDocs.deleteConfirm')" v-if="showDeletePopup" @confirm="deleteItem($event)" />
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import * as moment from "moment-timezone";
import DeleteModal from "@/components/DeleteModal.vue";
import { checkValueExists, checkDescriptionLength } from "../../services/helper";
import axios from "axios";
// import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { VueEditor } from "vue2-editor";
import Panzoom from "@panzoom/panzoom";
export default {
    name: "AIDocs",
    components: { DeleteModal, VueEditor },
    props: {
        hideHeader: { type: Boolean, default: false },
    },
    data() {
        return {
            checkValueExists,
            checkDescriptionLength,
            customToolbar: [
                // Text style
                ["bold", "italic", "underline", "strike"],

                // Headers and fonts
                [{ header: [1, 2, 3, 4, 5, 6, false] }],
                [{ font: [] }],
                [{ size: ["small", false, "large", "huge"] }],

                // Lists
                [{ list: "ordered" }, { list: "bullet" }],

                // Alignment
                [{ align: [] }],

                // Colors
                [{ color: [] }, { background: [] }],

                // Links, images, etc.
                ["link", "image"],

                // Clear formatting
                ["clean"]
            ],
            userTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            momentFormat: {
                stringify: (date) => {
                    return date ? moment(date).format('ll') : ''
                },
                parse: (value) => {
                    if (!value) return null
                    const formats = [
                        'll', 'LL',
                        'MMM D, YYYY', 'MMMM D, YYYY',
                        'M/D/YYYY', 'MM/DD/YYYY',
                        'M-D-YYYY', 'MM-DD-YYYY',
                        'YYYY-MM-DD', 'YYYY/MM/DD',
                        'D MMM YYYY', 'D MMMM YYYY',
                        'D/M/YYYY', 'DD/MM/YYYY',
                    ]
                    const m = moment(value, formats, true)
                    if (m.isValid()) return m.toDate()
                    const lenient = moment(value)
                    return lenient.isValid() ? lenient.toDate() : null
                }
            },
            editDocumentFlag: false,
            isTableMounted: false,
            items: [],
            perPage: 50,
            currentPage: 1,
            documentId: 0,
            emptyTable: false,
            isBusy: false,
            documentIndex: null,
            fileName: null,
            defaultData: {},
            showDeletePopup: false,
            media: null,
            // "pdf" or "image": what the preview should render.
            mediaType: null,
            sortBy: undefined,
            panzoom: null,
            mediaID: null,
            sortDesc: undefined,
            pageOptions: [
                {
                    value: 10,
                    text: "10",
                },
                {
                    value: 25,
                    text: "25",
                },
                {
                    value: 50,
                    text: "50",
                },
                {
                    value: 100,
                    text: "100",
                },
            ],
            documentData: {
                ai_doc_type: "Doc",
                tags: [],
                document: null,
                description: "",
                share_with_driver: true,
                _markdown_text: ""
            },
            errors: {
                date: null,
                ai_doc_type: "Doc",
                _markdown_text: "",
                document: null,
                description: null,
                share_with_driver: null
            },
        }
    },
    computed: {
        ...mapGetters(['company', "allCountries", "userCompany", 'rolePermissions', 'docTypeItems', 'tags', 'divisions']),
        allTags() {
            return this.tags.map((item) => {
                return {
                    id: item.id,
                    label: item.add_tag,
                }
            })
        },
        translatedFields() {
            return [
                { label: this.$t('aiDocs.descriptionColumn'), key: "description", sortable: true, thClass: 'font-table-weight-bold', stickyColumn: true, thStyle: { width: "200px" } },
                { key: "ai_doc_type", label: this.$t('aiDocs.typeColumn'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "share_with_driver", label: this.$t('aiDocs.tagsShareWithDriver'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "processing_status", label: this.$t('aiDocs.processingStatusColumn'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "Action", sortable: true, thClass: 'font-table-weight-bold' },
            ];
        },
        docTypeOptions() {
            return [
                { text: this.$t('aiDocs.pdfOption'), value: 'Doc' },
                { text: this.$t('aiDocs.articleOption'), value: 'Markdown' },
            ];
        },
    },
    watch: {
        perPage: {
            async handler() {
                await this.getAllDocs();
            },
            immediate: true,
        },
        currentPage: {
            async handler() {
                await this.getAllDocs();
            },
        },
        sortBy: {
            async handler() {
                await this.getAllDocs();
            },
        },
        sortDesc: {
            async handler() {
                await this.getAllDocs();
            },
        },
    },
    methods: {
        ...mapActions(['sendAIDocs', 'deleteAIDocuments', 'updateAIDocs', 'retrieveAIDocument', "setNotification", "setLoader", "getAIDocs"]),
        async updateDocumentOnToggle(data, value) {
            try {
                this.setLoader(true)
                data['share_with_driver'] = value;
                delete data.document;
                delete data.tags
                await this.updateAIDocs({
                    id: data.pk,
                    payload: data,
                });
                await this.setNotification({
                    msg: this.$t('documentsPage.docUpdatedShort'),
                    type: "success",
                    color: "green",
                });
                this.setLoader(false)
            } catch (error) {
                this.setLoader(false)
                await this.setNotification({
                    msg: error,
                    type: "error",
                    color: "red",
                });
            }
        },
        searchByKeys(searchQuery, field, filteredItems) {
            return filteredItems.filter(
                (x) =>
                    x[field] &&
                    x[field]
                        .toString()
                        .toLowerCase()
                        .includes(searchQuery.toString().toLowerCase())
            );
        },
        removeFile() {
            this.fileName = null;
            this.documentData.document = null
            this.media = null
            this.mediaType = null
            this.panzoom = null
        },
        resetField() {
            if (this.$refs.docFile) this.$refs.docFile.value = null;
        },
        async downloadDoc(id, name) {
            this.setLoader(true)
            const doc = await this.retrieveAIDocument(id);
            fetch(doc.document)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.blob();
                })
                .then(blob => {
                    const newUrl = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.style.display = 'none';
                    a.href = newUrl;
                    a.download = name
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(newUrl);
                    a.remove()
                    this.setLoader(false)
                })
                .catch(error => {
                    this.setLoader(false)
                    console.log(error)
                });
        },
        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (!value) {
                    nullKeys.push(key);
                }
            }
            return nullKeys;
        },
        deleteItem(item) {
            if (item) {
                this.deleteDocument(this.documentId);
            }
            this.showDeletePopup = false;
        },
        showDocumentDeletePopup(id) {
            this.showDeletePopup = true;
            this.documentId = id;
        },
        handleFileUpload() {
            this.documentData.document = this.$refs.docFile.files[0];
            this.fileName = this.documentData.document.name;
            this.media = URL.createObjectURL(this.documentData.document);
            this.mediaType = this.documentData.document.type.includes("pdf") ? "pdf" : "image";
            this.panzoom = null;
        },
        addDocument() {
            this.fileName = null;
            this.editDocumentFlag = false;
            this.defaultData = {}
            this.$bvModal.show("modal-company-ai-docs");
            this.documentData = {
                ai_doc_type: "Doc",
                document: null,
                description: null,
                share_with_driver: true,
                tags: [],
            };
            this.errors = {
                ai_doc_type: "Doc",
                _markdown_text: "",
                document: null,
                description: null,
                share_with_driver: null
            };
        },
        normalizeHtml(html) {
            return (html || '')
                .replace(/\r?\n|\r/g, '')
                .replace(/\s{2,}/g, ' ')
                .replace(/>\s+</g, '><')
                .replace(/\u200B/g, '')
                .trim();
        },
        async sendDocumentData() {
            const oldMarkdownText = this.normalizeHtml(this.defaultData._markdown_text);
            const newMarkdownText = this.normalizeHtml(this.documentData._markdown_text);
            try {
                if (this.documentData.description && this.checkDescriptionLength(this.documentData.description)) {
                    throw {
                        description: [this.$t('aiDocs.descriptionMaxLength')],
                    };
                }
                const nullKeys = this.checkNullValues({
                    ...this.documentData.ai_doc_type === 'Doc' ? { document: this.documentData.document } : { _markdown_text: this.documentData._markdown_text },
                    description: this.documentData.description
                });
                if (nullKeys.length === 0) {
                    this.setLoader(true);
                    let formData = new FormData();
                    let fileType = this.documentData.document instanceof File || this.documentData.document instanceof Blob;
                    if (!fileType) this.documentData.document = null
                    formData.append("description", this.documentData.description);
                    formData.append("ai_doc_type", this.documentData.ai_doc_type);
                    formData.append("share_with_driver", this.documentData.share_with_driver);
                    if (this.documentData.ai_doc_type === 'Doc' && this.documentData.document)
                        formData.append(
                            "document",
                            new File(
                                [this.documentData.document],
                                this.company[0].name + "_" +
                                this.documentData.description +
                                "_" + this.userCompany + "_" +
                                new Date().getTime() +
                                "." +
                                this.documentData.document["type"].split("/").pop(),
                                { type: this.documentData.document["type"] }
                            )
                        );
                    if (this.documentData.ai_doc_type === 'Markdown' && oldMarkdownText !== newMarkdownText) formData.append("_markdown_text", this.documentData._markdown_text);
                    formData.append("company_id", parseInt(localStorage.getItem("userSelectedCompany")));
                    this.documentData.tags.forEach((tag) => {
                        formData.append("tags", tag);
                    })
                    if (this.editDocumentFlag) {
                        this.documentData = await this.updateAIDocs({
                            id: this.documentData.pk,
                            payload: formData,
                        });
                        await this.setNotification({
                            msg: this.$t('aiDocs.docUpdated'),
                            type: "success",
                            color: "green",
                        });
                        this.$bvModal.hide("modal-company-ai-docs");
                        this.documentData = {
                            ai_doc_type: "Doc",
                            _markdown_text: "",
                            document: null,
                            description: null,
                            share_with_driver: true,
                            tags: [],
                        };
                        await this.getAllDocs();
                        this.fileName = null;
                    } else {
                        await this.sendAIDocs(formData);
                        await this.getAllDocs();
                        this.$bvModal.hide("modal-company-ai-docs");
                        await this.setNotification({
                            msg: this.$t('aiDocs.docAdded'),
                            type: "success",
                            color: "green",
                        });
                        this.documentData = {
                            ai_doc_type: "Doc",
                            _markdown_text: "",
                            document: null,
                            description: null,
                            share_with_driver: true,
                            tags: [],
                        };
                        this.fileName = null;

                    }
                }
                else {
                    let error = {};
                    nullKeys.forEach((x) => {
                        error[x] = [this.$t('aiDocs.fieldRequired')];
                    });
                    throw error;
                }
                this.setLoader(false);
            } catch (error) {
                this.setLoader(false);
                if (typeof error === "object") {
                    this.errors = error;
                    // eslint-disable-next-line no-ex-assign
                }
            }
        },
        async openLink(id) {
            const doc = await this.retrieveAIDocument(id);
            window.open(doc.document, "_blank");
        },
        async editDocument(id, docID) {
            this.editDocumentFlag = true;
            const doc = await this.openDoc(docID)
            this.documentIndex = id;
            this.documentData = { ...this.items[id] }
            this.documentData.tags = this.items[id].tags.length ? this.items[id].tags.map((tag) => tag.id) : []
            this.documentData._markdown_text = doc._markdown_text
            if (this.documentData.document) {
                let file_name = "";
                if (typeof this.documentData.document === "string") {
                    file_name = this.documentData.document;
                } else {
                    file_name = this.documentData.document.name;
                }
                this.fileName = file_name.substring(file_name.lastIndexOf("/") + 1);
            } else {
                this.documentData.document = null;
                this.fileName = "";
                this.errors = {
                    ai_doc_type: null,
                    _markdown_text: "",
                    document: null,
                    description: null,
                    share_with_driver: null
                };
            }
            this.defaultData = JSON.parse(JSON.stringify(this.documentData))
            this.$bvModal.show("modal-company-ai-docs");
        },
        async deleteDocument(id) {
            try {
                this.setLoader(true)
                await this.deleteAIDocuments(`${id}/?company_id=${this.userCompany}`);
                await this.setNotification({
                    msg: this.$t('aiDocs.docDeleted'),
                    type: "success",
                    color: "green",
                });
                this.$bvModal.hide("modal-company-ai-docs");
                await this.getAllDocs();
                this.setLoader(false)
            } catch (error) {
                this.setLoader(false)
                await this.setNotification({
                    msg: error,
                    type: "error",
                    color: "red",
                });
            }
        },
        async getAllDocs() {
            this.items = [];
            try {
                this.isBusy = true
                let url = ""
                if (this.sortBy) {
                    url += `sort_field=${this.sortBy}&sort_order=${this.sortDesc ? "desc" : "asc"}&`
                }
                else {
                    url += `sort_field=description&sort_order=asc&`
                }
                url += `page=${this.currentPage}&page_size=${this.perPage}`
                const docs = await this.getAIDocs({ url, company_id: this.userCompany })
                docs.data.forEach((doc, id) => {
                    this.items.push({
                        id: id,
                        pk: doc.id,
                        description: doc.description && doc.description !== 'null' ? doc.description : null,
                        name: `Ai Doc-${doc.description && doc.description !== 'null' ? doc.description.replace(/\./g, '') : ''}`,
                        ai_doc_type: doc.ai_doc_type,
                        tags: doc.tags,
                        document: doc.document,
                        processing_status: doc.processing_status,
                        share_with_driver: doc.share_with_driver
                    });
                    if (docs.total_entries_count) {
                        this.rows = docs.total_entries_count
                        const start = this.currentPage === 1 ? 1 : (this.perPage * (this.currentPage - 1)) + 1
                        const end = this.perPage * (this.currentPage - 1) + docs.queryset_count
                        this.positionText = this.$t('documentsPage.positionText', { start, end, total: docs.total_entries_count })
                    }
                    else {
                        this.rows = 0
                        this.positionText = this.$t('documentsPage.emptyPosition')
                    }
                    if (this.items.length === 0) this.emptyTable = true
                    else this.emptyTable = false
                })
            }
            catch (e) {
                console.log(e)
            }
            finally {
                this.isTableMounted = true
                this.isBusy = false
            }
        },
        async openDoc(id) {
            const doc = await this.retrieveAIDocument(id);
            this.media = doc.document
            // The link is signed, so the extension has to be read before the query.
            this.mediaType = this.mediaTypeFor(doc.document)
            this.panzoom = null
            this.mediaID = id
            this.itemId = id;
            return doc
        },
        mediaTypeFor(url) {
            const path = `${url || ""}`.split("?")[0].toLowerCase();
            return path.endsWith(".pdf") ? "pdf" : "image";
        },
        // Built on first use, like the Documents preview does it.
        zoom(level) {
            if (!this.panzoom) {
                this.panzoom = Panzoom(document.getElementById("ai-panzoom-element"), { maxScale: 5 });
            }
            level === -1 ? this.panzoom.zoomOut() : this.panzoom.zoomIn();
        },
        downloadFile(uri) {
            axios({
                method: 'get',
                url: uri,
                responseType: 'blob',
            }).then(response => {
                const blob = new Blob([response.data], { type: response.headers['content-type'] });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                const fileName = this.docName
                a.download = fileName
                document.body.appendChild(a);
                a.click();
                a.remove()
                window.URL.revokeObjectURL(url);
            });
        },
    },
}
</script>
<style>
.ai-markdown-editor .ql-toolbar.ql-snow {
    border: 1px solid #e3e3e3;
    border-bottom: none !important;
    border-radius: 5px 5px 0 0 !important;
}

.ai-markdown-editor .ql-container.ql-snow {
    border: none !important;
}

.ai-markdown-editor .ql-container.ql-snow a {
    color: #2D69F6 !important;
}

.ai-markdown-editor .ql-container.ql-snow .ql-editor {
    border-top-right-radius: 0px;
    border-top-left-radius: 0px;
    min-height: 380px !important;
}
</style>